import Vue from "vue";
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDUapEUM8KfcNxAMA66QMCXLbKm27oHnWk',
    libraries: 'places'
  }
})